import {dateField, EntityData, field} from "@fedeltapointofsale/data-client";

export class AccSingleInvReportData extends EntityData<AccSingleInvReportData> {
    @field addressAccount: number = 0;
    @field RECEIPTNO: string;
    @field ACCOUNTNO: string;
    @field ACCOUNTNAME: string;
    @field COPYONLY: boolean = true;
    @field SIGN4GOODS: boolean = false;
    @field BILLINGCYCLE: string;
    @field TERMS: number;
    @field TERMSCOMMENT: string;
    @dateField DUEDATE: Date;
    @field HEADER: string;
    @field FOOTER: string;
    @field CREDITFOOTER: string;
    @field specifyInvoicingDetails: boolean;

}
